export default __webpack_public_path__ + "static/media/etl.5b86a887.png";